import { lazy } from "react";
import AuthLayout from "layout/Auth";
import Loadable from "components/Loadable";
import ErrorBoundary from "./ErrorBoundary";

const AuthLogin = Loadable(lazy(() => import("pages/auth/login")));
const AuthForgotPassword = Loadable(
  lazy(() => import("pages/auth/forgot-password"))
);
const AuthResetPassword = Loadable(
  lazy(() => import("pages/auth/reset-password"))
);
const LoginRoutes = {
  path: "/admin",
  element: <AuthLayout />,
  errorElement: <ErrorBoundary />,
  children: [
    {
      children: [
        {
          path: "login",
          element: <AuthLogin />,
        },
        {
          path: "forgot-password",
          element: <AuthForgotPassword />,
        },
        {
          path: "reset-password/:code",
          element: <AuthResetPassword />,
        },
      ],
    },
  ],
};

export default LoginRoutes;
